export default "__VITE_ASSET__YUu6b$Al__"